import { useEffect } from 'react';

// Assignment batches can emit hundreds of events. Refresh server totals/pages
// once the burst settles, rather than issuing a request per individual ticket.
export function useTicketRefresh(refresh: (fresh?: boolean) => void | Promise<void>) {
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    let running = false, queued = false, disposed = false, force = false;
    const run = async () => {
      timer = undefined;
      if (running) { queued = true; return; }
      running = true;
      const fresh = force; force = false;
      try { await refresh(fresh); }
      finally {
        running = false;
        if (queued && !disposed) { queued = false; schedule(); }
      }
    };
    const schedule = () => {
      if (disposed) return;
      clearTimeout(timer);
      timer = setTimeout(() => { void run(); }, 250);
    };
    const focus = () => { force = true; schedule(); };
    window.addEventListener('nova:ticket-change', schedule);
    window.addEventListener('focus', focus);
    return () => {
      disposed = true;
      clearTimeout(timer);
      window.removeEventListener('nova:ticket-change', schedule);
      window.removeEventListener('focus', focus);
    };
  }, [refresh]);
}
